import { CustomData } from 'owa-analytics-actions';
import { getCurrentUrl } from 'window-utils/lib/getCurrentUrl';
import { logUsage } from 'owa-analytics';

export const logTelemetry = (eventName: string, customData?: CustomData) => {
    logUsage(eventName, { ...customData, currentUrl: getCurrentUrl() });
};
